import Big from 'big.js'
import {
  wisePayoutMinLivePoints,
  wisePayoutMaxLivePoints,
} from '../models/Wise'

export class WiseService {
  constructor() {}

  canCash(amountOfLivePoints: number): boolean {
    return (
      amountOfLivePoints >= wisePayoutMinLivePoints &&
      amountOfLivePoints <= wisePayoutMaxLivePoints
    )
  }

  cash(amountOfLivePoints: number, rate: Big): Big {
    return new Big(rate.mul(amountOfLivePoints).toFixed(2))
  }
}
